import { FC, PropsWithChildren } from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  border-radius: 4px;
  border-width: 1px;
  border-color: #bdc1caff;
  border-style: solid;
  position: relative;
  padding: 32px 12px 12px;
`;

const Title = styled.div`
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #565d6dff;
  position: absolute;
  top: 0;
  transform: translate(0, -50%);
  padding: 0 8px;
  background-color: #fff;
`;

const Filters: FC<PropsWithChildren<{ title: string }>> = ({
  children,
  title,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      {children}
    </Container>
  );
};

export default Filters;
